// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18hW3","name":"Header_name__3emh6","birthday":"Header_birthday__4laWy","skeleton":"Header_skeleton__2wGMV"};